import { get, http } from './request'

export const getPath = (data, success, failure) => {
    return get(
      data.path,
      response => success(response),
      error => failure(error),
      { params: data.params }
    )
  }

export const downloadFile = (path, success, failure, params = {}) => {
  return http({
    method: 'get',
    url: path,
    responseType: 'blob',
    params,
  }
  ).then(response => success(response))
    .catch(error => failure(error))
}


